.BillingContainer
    position: absolute
    top: 0
    bottom: 0
    left: 0
    right: 0
    width: 100%
    display: flex
    flex: 1
    flex-direction: column
    align-items: center
    background: rgb($globalSettingsBackgroundPrimary)
    justify-content: space-between
    font-size: 14px
    color: rgb($globalSettingsFontPrimary)
    overflow: auto
    box-sizing: border-box

.BillingContainerInner
    width: 100%
    padding: 0 20px
    display: flex
    flex-direction: column
    flex-shrink: 0
    box-sizing: border-box

.BillingTitle
    font-size: 16px
    font-weight: 700
    width: 100%

.InputField
    width: 100%

.spacerOne
    display: none

@media #{$tablet}
    .MobileOnly
        display: none

    .BillingContainerInner
        padding: 0 30px

    .FieldsContainer
        display: flex
        flex-direction: row
        flex-wrap: wrap
        justify-content: space-between

    .InputField
        width: calc(50% - 10px)

    .CheckboxContainer
        width: 100%

    .spacerOne
        display: inherit
        width: 100%
        height: 30px
        flex-shrink: 0

    .OtherShippingAddress
        width: 100%
        display: flex
        flex-direction: row
        flex-wrap: wrap
        justify-content: space-between
        order: 100
        .spacerThree
            order: 4
            display: inherit
            width: 100%
            height: 30px
            flex-shrink: 0
        .spacerFour
            order: 10
            display: inherit
            width: 100%
            height: 30px
            flex-shrink: 0
